export default {
    campaignCategoryListWithChildren: []
}